import { SceneType } from "./abstract";
import { initUserInfo, IUserInfo } from "./userInfo";

// ゲストランク
export const GuestTypes = {
  Green: "green",
  Red: "red",
  Blue: "blue",
  Pink: "pink",
  Gold: "gold",
  Platinum: "platinum",
  Black: "black",
} as const;
export type GuestType = typeof GuestTypes[keyof typeof GuestTypes];

export interface IGuest extends IUserInfo {
  guestType: GuestType;
  sceneTag: SceneType[];
  point?: number;
  isApproval?: boolean;
}

export const initGuest: IGuest = Object.assign(initUserInfo, {
  guestType: GuestTypes.Green,
  sceneTag: [],
  point: 0,
});

// ゲスト使用履歴情報
export interface IGuestPayment {
  paymentId: string;
  eventDate: string;
  eventStartTime?: string;
  eventEndTime?: string;
  eventUsageTime?: number;
  discount?: number;
  eventPaymentPoint: number;
  castPaymentList?: IGuestPaymentPersonalCastInfo[];
}

export interface IGuestPaymentPersonalCastInfo {
  name: string;
  startTime: string;
  endTime: string;
  paymentPoint: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isIGuest(data: any): data is IGuest {
  return data.guestType !== undefined;
}
